import type { PreferencesConfig } from '@models/company'

export const DEFAULT_ORDERS_TABLE_COLUMNS = [
  'userFullName',
  'routeExternalId',
  'customerName',
  'orderExternalId',
  'status',
  'date',
  'proofDelivery',
  'paymentMethod',
  'actualArrivalDate',
  'cost',
  'rejectionReason',
  'settings',
  'cancelOrder',
  'actions',
] as const

export const getDefaultOrderTabs = (
  isSimplifiedOrdersCompany: boolean,
): PreferencesConfig['orders']['orderInfo']['navigation']['tabs'] => ({
  wares: {
    index: 0,
    hidden: isSimplifiedOrdersCompany,
    table: {
      columns: [
        'name',
        'category',
        'brand',
        'delivered',
        'to_depot',
        'details',
        'settings',
      ],
    },
  },
  orderInfo: {
    index: 1,
    hidden: false,
    data: {
      items: [
        'status',
        'client',
        'courier',
        'plannedTime',
        'actualTime',
        'payment',
        'reason',
        'notes',
      ],
    },
  },
  eta: {
    index: 2,
    hidden: true,
  },
  goodsDeliveryNote: {
    index: 3,
    hidden: false,
  },
  packagingReturnReport: {
    index: 4,
    hidden: false,
  },
})

export const PREFERENCES: { [key: string]: PreferencesConfig } = {
  v1a3131: {
    primaryOrderId: 'invoiceId',
    depots: {
      hidden: false,
    },
    orders: {
      hidden: false,
      exportToXls: false,
      filters: {
        date: {
          hidden: false,
          defaultValue: [0, 0],
          isCustomComponent: true,
        },
        depotId: {
          hidden: true,
        },
        companyPartnerId: {
          hidden: false,
        },
        searchText: {
          hidden: false,
          isSearchAcrossAllDates: true,
          translations: {
            placeholder:
              'pages.companies.orders.filters.order_search_client_placeholder',
          },
        },
      },
      table: {
        columns: [
          'customerName',
          'orderExternalId',
          'invoiceId',
          'address',
          'orderExternalPartnerId',
          'partnerName',
          'status',
          'proofDelivery',
          'actualArrivalDate',
          'settings',
        ],
      },
      navigation: {
        tabs: ['orders'],
      },
      orderInfo: {
        navigation: {
          tabs: {
            orderInfo: {
              index: 0,
              hidden: false,
              data: {
                items: [
                  'status',
                  'client',
                  'courier',
                  'address',
                  'plannedTime',
                  'actualTime',
                  'notes',
                ],
              },
            },
            wares: {
              index: 1,
              hidden: false,
              table: {
                columns: [
                  'name',
                  'category',
                  'brand',
                  'delivered',
                  'to_depot',
                  'details',
                  'settings',
                ],
              },
            },
            eta: {
              index: 2,
              hidden: false,
            },
            goodsDeliveryNote: {
              index: 3,
              hidden: false,
            },
            packagingReturnReport: {
              index: 4,
              hidden: false,
            },
          },
        },
      },
    },
    stopOrders: {
      hidden: false,
      table: {
        columns: [
          'selected',
          'orderExternalId',
          'invoiceId',
          'status',
          'date',
          'paymentMethod',
          'actualArrivalDate',
          'cost',
          'actions',
        ],
      },
    },
    users: {
      hidden: false,
      rolesVisibility: ['COMPANY_SUPER_ADMIN'],
      roles: {
        availableRoles: [
          'COMPANY_MANAGER',
          'COMPANY_DISPATCHER',
          'COMPANY_REGIONAL_MANAGER',
        ],
        translations: {
          COMPANY_REGIONAL_MANAGER: 'pages.companies.users.form.ksm',
          COMPANY_MANAGER: 'pages.companies.users.form.hq_plus',
          COMPANY_DISPATCHER: 'pages.companies.users.form.hq_region',
        },
      },
    },
    partners: {
      hidden: false,
      rolesVisibility: ['COMPANY_SUPER_ADMIN'],
    },
    routes: {
      hidden: false,
    },
    packaging: {
      hidden: false,
    },
    waresToDepot: {
      hidden: false,
    },
    finances: {
      hidden: true,
    },
    vehicles: {
      hidden: false,
    },
    locations: {
      hidden: false,
    },
    settings: {
      homePage: 'orders',
      theme: 'v1a3131',
    },
  },
}
